import { Component, OnInit } from '@angular/core';
import { SideBarService } from './sidebar.service';

@Component({
  selector: 'ntc-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {

  menuItens = [
    {
      name: 'Pessoa',
      items: [
        {Link: '/assinantes', name: 'Assinantes'},
        {Link: '/empresa', name: 'Empresas'},
        {Link: '/equipe', name: 'Equipes'},
        {Link: '/tecnico', name: 'Técnicos'},
        {Link: '/logradouro-cep', name: 'Logradouro Ceps'},
        {Link: '/logradouro', name: 'Logradouros'},
        {Link: '/localidade', name: 'Localidade (Cidade)'},
        {Link: '/bairro', name: 'Bairros'},
        {Link: '/estado', name: 'Estados'},
        {Link: '/pais', name: 'Países'},
        {Link: '/endereco-local-tipo', name: 'Tipos de Endereço Local'},
        {Link: '/filial', name: 'Filiais'},
        {Link: '/fabricante', name: 'Fabricantes'},
        {Link: '/fornecedor', name: 'Fornecedor'},
        {Link: '/usuarios-sistema', name: 'Usuários do Sistema'},
        {Link: '/banco-agencia', name: 'Agências Bancárias'},
        {Link: '/banco', name: 'Bancos'},
        {Link: '/usuario-grupo', name: 'Grupos de Usuário'},
        {Link: '/religiao', name: 'Religiões'},
        {Link: '/profissao', name: 'Profissões'}
      ]
    },
    {
      name: 'Atendimento',
      items: [
        {Link: '/protocolo-tipo', name: 'Tipos de Protocolo'},
        {Link: '/protocolo-atendimento-tipo', name: 'Tipos de Protocolo Atendimento'},
        {Link: '/protocolo-assunto', name: 'Assuntos de Protocolo'},
        {Link: '/protocolo-motivo', name: 'Motivos de Protocolo'},
        {Link: '/protocolos', name: 'Protocolos'}
      ]
    },
    {
      name: 'Produto',
      items: [
        {Link: '/produto', name: 'Produtos'},
        {Link: '/funcao-equipamento', name: 'Funções de Equipamento'},
        {Link: '/produto-segmento', name: 'Segmentos de Produto'},
        {Link: '/promocao', name: 'Promoções'},
        {Link: '/produto-promocao', name: 'Promoções de Produto'},
        {Link: '/produto-pacote', name: 'Pacotes de Produto'},
        {Link: '/canal', name: 'Canal'}
      ]
    },
    {
      name: 'Item',
      items: [
        {Link: '/item', name: 'Itens'},
        {Link: '/', name: 'Itens Componente'},
        {Link: '/', name: 'Itens Equipamento'},
        {Link: '/item-serie', name: 'Itens Série'},
        {Link: '/motivo-inativacao', name: 'Motivos de Inativação'}
      ]
    },
    {
      name: 'Contrato',
      items: [
        {Link: '/contratos', name: 'Contratos'},
        {Link: '/cliente-tipo', name: 'Tipos de Cliente'},
        {Link: '/autorizacao-tipo', name: 'Tipos de Autorização'},
        {Link: '/linha-telefonica', name: 'Linhas Telefônicas'},
        {Link: '/operadora', name: 'Operadoras'},
        {Link: '/cobranca-tipo', name: 'Tipos de Cobrança'}
      ]
    },
    {
      name: 'Ordem de Serviço',
      items: [
        {Link: '/servico', name: 'Serviços'},
        {Link: '/ordens-servico', name: 'Ordens de Serviço'},
        {Link: '/motivo-cancelamento', name: 'Motivos de Cancelamento'}
      ]
    },
    {
      name: 'Outros',
      items: [
        {Link: '/tecnico/mapa-tecnico', name: 'Mapa do Técnico'},
        {Link: '/endereco-ws-cep', name: 'Endereço CEP (WebService)'}
      ]
    }
  ];

  widthSideBar = 'inherit';

  constructor(public sideBar: SideBarService) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/sidebar/sidebar.component.ts